import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';
import { getFileMapping } from '../store/selectors';
import { setMergeStrategy } from '../store/actions/mapping';

const tooltipMessage = 'When a row in the CSV is determined to map to an existing record,' +
  ' how should the row data be merged.';
const options = [{
  label: 'Merge if blank',
  value: 'merge_if_blank',
  description: 'Data will only be merged into blank fields. Nothing will be overwritten.'
}, {
  label: 'Overwrite all',
  value: 'overwrite_all',
  description: 'All data will be merged. Existing data may be overwritten.'
}, {
  label: 'Skip all',
  value: 'skip_all',
  description: 'No data will be merged. Existing records will only serve as association targets.'
}];

export function MappingSettings({ fileMapping, setMergeStrategy }) {

  const onChangeValue = (event) => {
    setMergeStrategy(event.target.value);
  };

  const renderOption = (option) => {
    return (
      <tr className={classNames({ selected: option.value === fileMapping.mergeStrategy })} key={option.value}>
        <td>
          <input checked={option.value === fileMapping.mergeStrategy}
            type="radio"
            value={option.value} onChange={onChangeValue}
          />
        </td>
        <td>
          <label>{option.label}</label>
          <p>{option.description}</p>
        </td>
      </tr>
    );
  };

  return (
    <div className="settings my-5">
      <div className="mb-4">
        <h3 className="semi-bold mb-4">Settings</h3>
        <p className="mt-4">
          Configure how the importer should behave in certain situations.
        </p>
      </div>
      <table className="table table-bordered thead-inverse">
        <thead>
          <tr>
            <th className="dark" colSpan="2">
              Update Merge Strategy
              <a className="pull-right">
                <Tooltip
                  content={tooltipMessage}
                  overlayClassName="tooltip-popover-dark"
                  placement="top"
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </Tooltip>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          {options.map(renderOption)}
        </tbody>
      </table>
    </div>
  );
}

MappingSettings.propTypes = {
  fileMapping: PropTypes.object.isRequired,
  setMergeStrategy: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  fileMapping: getFileMapping(state)
});

const mapDispatchToProps = {
  setMergeStrategy
};

export default connect(mapStateToProps, mapDispatchToProps)(MappingSettings);
